import moment from "moment";

// Presentación de valores de atributos en la tabla de atributos y en los
// popups de consulta (FeaturePopup / FeaturePopupExpanded).

// GeoServer serializa date/timestamp como "2026-09-21Z" o
// "2026-09-21T00:00:00Z": se exige zona para no reformatear campos de texto
// que solo parecen fecha (p. ej. fecha_str = "2026-09-21").
const ISO_WITH_ZONE = /^\d{4}-\d{2}-\d{2}(T[\d:.]+)?(Z|[+-]\d{2}:?\d{2})$/;

export const isZonedIsoDate = value => typeof value === "string" && ISO_WITH_ZONE.test(value.trim());

// Epoch (ArcGIS esriFieldTypeDate) se lee en UTC: las fechas calendario
// vienen guardadas a medianoche UTC y en hora local se correrían un día.
// ponytail: medianoche → solo fecha; esriFieldTypeDate no distingue date de datetime
export const formatDateValue = value => {
  const date = typeof value === "number"
    ? moment.utc(value)
    : moment.parseZone(value.trim(), [moment.ISO_8601, "YYYY-MM-DDZ"]);
  if (!date.isValid()) return String(value);
  return date.format(date.hours() || date.minutes() || date.seconds() ? "DD-MM-YYYY HH:mm" : "DD-MM-YYYY");
};

// Valores con HTML simple (p. ej. <a href>Ver ficha</a> de servicios ArcGIS
// externos) se interpretan reconstruyendo el árbol en un documento inerte:
// solo tags de ALLOWED, sin atributos salvo href http(s) en <a>. Otros tags
// conservan su texto; los de DROP se descartan con su contenido.
const ALLOWED = new Set(["A", "B", "STRONG", "I", "EM", "U", "BR", "SPAN", "P"]);
const DROP = new Set(["SCRIPT", "STYLE", "TEMPLATE", "NOSCRIPT"]);

export const sanitizeHtml = value => {
  const source = new DOMParser().parseFromString(String(value ?? ""), "text/html");
  const output = document.implementation.createHTMLDocument("");
  const copy = (from, to) => from.childNodes.forEach(node => {
    if (node.nodeType === Node.TEXT_NODE) { to.appendChild(output.createTextNode(node.textContent)); return; }
    if (node.nodeType !== Node.ELEMENT_NODE || DROP.has(node.tagName)) return;
    if (!ALLOWED.has(node.tagName)) { copy(node, to); return; }
    const element = output.createElement(node.tagName);
    if (node.tagName === "A") {
      const href = (node.getAttribute("href") || "").trim();
      if (/^https?:\/\//i.test(href)) {
        element.setAttribute("href", href);
        element.setAttribute("target", "_blank");
        element.setAttribute("rel", "noopener noreferrer");
      }
    }
    copy(node, element);
    to.appendChild(element);
  });
  copy(source.body, output.body);
  return output.body.innerHTML;
};

export const stripHtml = value => new DOMParser().parseFromString(String(value ?? ""), "text/html").body.textContent;
